import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import {
  MatButtonToggleModule
} from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SwitchComponent } from '@shared/components/ui/switch';
import { HorusLoadingComponent } from '@shared/components/domain/horus-loading/horus-loading.component';
import { HorusMessageGeneralComponent } from '@shared/components/domain/horus-message-general/horus-message-general.component';
import { OrdersGlobalState } from '../../services/orders-global.state';
import { OrderAccordionComponent } from '../order-accordion/order-accordion.component';
import { SimpleLogger, LOG_MODULES } from '@core/services/logging';
import { TenantUrlUtilService } from '@shared/services/tenant-url-util.service';

@Component({
  selector: 'app-orders-panel',
  standalone: true,
  imports: [
    CommonModule,
    OrderAccordionComponent,
    MatButtonToggleModule,
    SwitchComponent,
    MatFormFieldModule,
    MatSelectModule,
    HorusMessageGeneralComponent,
    HorusLoadingComponent,
  ],
  templateUrl: './orders-panel.component.html',
  styleUrl: './orders-panel.component.scss',
})
export class OrdersPanelComponent {
  selectedStatus = '';

  checked = false;
  disabled = false;

  private openSignal = signal(true);
  isOpen = this.openSignal.asReadonly();

  readonly state = inject(OrdersGlobalState);
  private readonly logger = inject(SimpleLogger);
  private readonly tenantUrlUtil = inject(TenantUrlUtilService);

  onStatusChange(
    status: 'IN_PROGRESS' | 'DELIVERED' | 'CANCELED' | null
  ): void {
    const tenantInfo = this.tenantUrlUtil.tenantUrlInfo();
    
    this.logger.info('User changed status filter', {
        module: 'ORDERS',
        action: 'apply-status-filter',
        tenantId: tenantInfo.tenant,
        status: status || 'ALL',
        previousStatus: this.selectedStatus || 'ALL'
      });
    
    this.state.setStatusFilter(status);
    this.selectedStatus = status!;
  }

  onOrderTypeChange(type: string): void {
    const tenantInfo = this.tenantUrlUtil.tenantUrlInfo();
    
    this.logger.info('User changed order type filter', {
        module: 'ORDERS',
        action: 'apply-type-filter',
        tenantId: tenantInfo.tenant,
        type: type || 'ALL',
        previousType: this.state.orderTypeFilter() || 'ALL'
      });
    
    this.state.orderTypeFilter.set(type || null);
  }

  toggle() {
    const tenantInfo = this.tenantUrlUtil.tenantUrlInfo();
    const newState = !this.openSignal();
    
    this.logger.info('User toggled orders panel', {
        module: 'ORDERS',
        action: 'user-action',
        tenantId: tenantInfo.tenant,
        actionDetail: 'toggle-panel',
        newState: newState ? 'open' : 'closed'
      });
    
    this.openSignal.update((val) => !val);
  }

  getReadableStatus(): string {
    switch (this.selectedStatus) {
      case 'IN_PROGRESS':
        return 'En curso';
      case 'DELIVERED':
        return 'Completados';
      case 'CANCELED':
        return 'Cancelados';
      default:
        return 'Todos';
    }
  }
}
